import Button from '@creditflowresearch/uilib/Button';
import IconRefresh from '@creditflowresearch/uilib/Icon/IconRefresh';
import IconWarning from '@creditflowresearch/uilib/Icon/IconWarning';
import styles from '../askAiChat.module.scss';

interface IMessageErrorProps {
  text?: string,
  onRetry: () => void,
}

const MessageError = ({ text, onRetry }: IMessageErrorProps) => (
  <div className={ styles.errorActions }>
    <IconWarning className={ styles.errorIcon } />
    <p className={ styles.errorText } data-test="askAiChatMessageError">
      { text || 'Something went wrong. Please try again.' }
    </p>
    <Button
      variant="outline"
      color="error"
      size="S"
      icon={ <IconRefresh /> }
      onClick={ onRetry }
      dataTest="askAiChatRetryButton"
    >
      Retry
    </Button>
  </div>
);

export default MessageError;
